import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRestContext } from 'components/form/RestInputContext';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import StatusLabel from '../../StatusLabel';
import {
  APPROVED_SUB_STATUS,
  RETURN_CHANNEL,
  RETURN_STATUS,
} from 'constants/ordersReturn';
import { useDispatch, useSelector } from '@redux';
import { Button, Dropdown, MenuProps, Space } from 'antd';
import CancelModal from './ModalConfirm/CancelModal';
import { useRef, useState } from 'react';
import { DownOutlined } from '@ant-design/icons';
import {
  getByIdOrdersReturn,
  markAsReceived,
  markAsSuccess,
} from '@redux/ordersReturn/actions';
import { newCheckRole } from 'utils/tools';
import { DynamicObjectType } from 'types/commons';

export default function OrderCurrentStatus({
  isLayoutEditProducts,
  setIsLayoutEditProducts,
}) {
  console.log(isLayoutEditProducts, setIsLayoutEditProducts);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { record } = useRestContext();
  const navigate = useNavigate();
  const params = useParams();
  const [markAsReceivedShow, setMarkAsReceivedShow] = useState(true);
  const refCancelModal = useRef<{ open: () => void }>();

  const user = useSelector<DynamicObjectType>((state) => state.auth.data);
  const loading = useSelector<boolean>(
    (state) => state['ordersReturn'].itemLoadings[params?.id],
  );

  // const handleEdit = () => {
  //   setIsLayoutEditProducts((value) => !value);
  // };

  // const handleSave = () => {
  //   form.submit();
  //   setIsLayoutEditProducts((value) => !value);
  // };

  const handleMaskAsSuccess = () => {
    dispatch(
      markAsSuccess({
        data: { id: record?.id },
        options: { isShowSuccessNoti: true },
      }),
    ).then(() => {
      dispatch(
        getByIdOrdersReturn({
          data: { id: record?.id },
          options: { isRequestApi: true, isRefresh: true },
        }),
      );
    });
  };

  const handleMarkedAsReceived = () => {
    dispatch(
      markAsReceived({
        data: { id: record?.id },
        options: { isShowSuccessNoti: true },
      }),
    ).then((res) => {
      if (res?.payload?.id) {
        setMarkAsReceivedShow(false);
      }
    });
  };

  const items: MenuProps['items'] = [
    record?.isMarketPlace &&
      newCheckRole(
        '/return-orders/:returnId/mark-as-success',
        'POST',
        user?.roles,
        user?.isSuperUser,
      ) && {
        key: '1',
        label: (
          <Button
            loading={loading}
            type="link"
            className="text-black"
            onClick={handleMaskAsSuccess}
          >
            <p className="!text-black !hover:text-black">Mark as success</p>
          </Button>
        ),
      },
    !record?.physicalGoodsReceived &&
      markAsReceivedShow &&
      newCheckRole(
        '/return-orders/:returnId/mark-as-received',
        'POST',
        user?.roles,
        user?.isSuperUser,
      ) && {
        key: '2',
        label: (
          <Button
            loading={loading}
            type="link"
            className="text-black"
            onClick={handleMarkedAsReceived}
          >
            <p className="!text-black !hover:text-black">Marked as Received</p>
          </Button>
        ),
      },
  ];

  return (
    <div className="flex items-center justify-between">
      <div>
        <div className="flex items-center gap-[10px]">
          <FontAwesomeIcon
            icon={faChevronLeft}
            className="text-[12px] cursor-pointer"
            onClick={() => navigate('/orders-return')}
          />
          <div className="text-text-dark-gray font-bold">{`${t('ordersReturn.summary.returnRequestID')}:`}</div>
          <div className="text-text-primary font-bold">{`#${record?.id}`}</div>
          <StatusLabel status={record?.status} dataFull={RETURN_STATUS} />
        </div>
        <div className="flex items-center gap-[10px] text-text-dark-gray">
          <div>{`${t('ordersReturn.fromWarehouse')}:`}</div>
          <div className="font-bold">{record?.order?.location?.name || ''}</div>
          {'-'}
          <div>{`${t('ordersReturn.toWarehouse')}:`}</div>
          {record?.returnType === RETURN_CHANNEL['OFFLINE'].value ? (
            <div className="font-bold">
              {record?.returnWarehouse?.name || ''}
            </div>
          ) : (
            <div className="font-bold">
              {record?.order?.location?.name || ''}
            </div>
          )}{' '}
        </div>
      </div>
      {record?.status === RETURN_STATUS['APPROVED'].value &&
        record?.shippingStatus ===
          APPROVED_SUB_STATUS['WAITING_FOR_PICKUP'] && (
          <>
            <Button
              loading={loading}
              onClick={() => refCancelModal.current.open()}
              type="primary"
              className="btn-h-32"
            >
              {t('button.cancelOrderReturn')}
            </Button>
            <CancelModal
              id={record?.id || params?.id}
              ref={refCancelModal}
              initValue={{
                cancelReason: record?.cancelReason,
              }}
            />
          </>
        )}
      {record?.status === RETURN_STATUS['APPROVED'].value &&
        items?.filter((i) => Boolean(i))?.length > 0 && (
          <Dropdown menu={{ items }}>
            <Button>
              <Space>
                Option
                <DownOutlined />
              </Space>
            </Button>
          </Dropdown>
        )}
      {/* {record?.status === RETURN_STATUS['AWAITING_APPROVAL'].value && (
        <>
          {isLayoutEditProducts ? (
            <Button
              loading={loading}
              onClick={handleSave}
              type="primary"
              className="btn-h-32"
            >
              {t('button.save')}
            </Button>
          ) : (
            <Button onClick={handleEdit} type="primary" className="btn-h-32">
              {t('button.edit')}
            </Button>
          )}
        </>
      )} */}
    </div>
  );
}
